import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { loadProfessional } from 'src/app/store/professional/professional.actions';
import { selectActivatedProfessional } from 'src/app/store/professional/professional.selectors';

@Component({
  selector: 'app-search-expenses',
  templateUrl: './search-expenses.component.html',
  styleUrls: ['./search-expenses.component.scss']
})
export class SearchExpensesComponent implements OnInit{
  data = this.config.data

  selectedDate: any
  selectedProfessional: any
  selectedCategory: any

  professionalOptions!: any[]

  professionalList$ = this.store.select(selectActivatedProfessional)
  
  constructor(public config: DynamicDialogConfig, private store: Store) { }

  ngOnInit(): void {
    this.store.dispatch(loadProfessional());

    this.professionalList$.subscribe({
      next: res => this.professionalOptions = res,
      error: err => console.log(err)
    })
  }

  addProfessionalFilter(){
    console.log('professional: ', this.selectedProfessional)
  }
}
